import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

// Docs: https://github.com/hilongjw/vue-lazyload
Vue.use(VueLazyload)
